import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(!!window.localStorage.getItem('token'));

  const login = (token) => {
    window.localStorage.setItem('token', JSON.stringify(token));
    setIsLoggedIn(true);
  };

  const logout = () => {
    window.localStorage.removeItem('token');
    setIsLoggedIn(false);
  };

  useEffect(() => {
    // Check if token exists on app load
    const token = window.localStorage.getItem('token');
    setIsLoggedIn(!!token);
  }, []);

  const value = {
    isLoggedIn,
    login,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
